import { Box, Dialog, DialogContent, ThemeProvider, Typography } from '@mui/material'
import { ReactComponent as ExclamationIcon } from './assets/exclaimation.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import Errors from 'Components/Elements/Errors/Errors'
import { DefaultButton } from 'Components/Elements/Forms'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { MainTemplate } from 'Components/Template/MainTemplate'
const ModalHandleError = ({ open, errorDetails = [], onClose, closeOnly = false, description = null, reload = false }) => {
    const translate = useTranslate()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    // อยู่หน้าแรกแล้วยังมี uuid ค้างใน url = uuid หมดอายุ reload ซ้ำก็เจอ error เดิมไม่จบ
    // ทิ้ง uuid ก่อนโหลดใหม่ (replace ไม่ให้ปุ่ม Back ย้อนกลับไป url ที่พัง)
    const reloadWithoutStaleUuid = () => {
        const url = new URL(window.location.href)

        if (pathname === '/' && url.searchParams.has('uuid')) {
            url.searchParams.delete('uuid')
            return window.location.replace(url.toString())
        }

        return window.location.reload()
    }

    const descriptionHtml = (() => {
        if (!description) return translate('desciption_handle_api_error')
        const v = translate(description.key, { defaultDisplay: description.fallback })
        return !v || v === description.key ? description.fallback : v
    })()

    return (
        <ThemeProvider theme={MainTemplate}>
        <Dialog
            open={open}
            disableEscapeKeyDown
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '16px !important',
                    boxShadow: 'none !important',
                    maxWidth: '480px',
                    width: '100%',
                    backgroundColor: '#F4F8FB'
                }
            }}>
            <DialogContent sx={{ padding: '30px'}}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: '16px'
                    }}>
                    <Box
                        sx={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 99, 99, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                        <ExclamationIcon />
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Typography
                            sx={{
                                fontSize: '24px',
                                fontWeight: 700,
                                color: '#003B6F',
                                fontFamily: 'Inter',
                                lineHeight: 1.3
                            }}>
                            {translate('title_modal_handdle_error')}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px !important',
                                fontWeight: 400,
                                color: '#5A8FC3',
                                fontFamily: 'Inter',
                                lineHeight: '20px',
                            }}
                            dangerouslySetInnerHTML={{
                                __html: descriptionHtml
                            }}
                        />
                    </Box>

                    {errorDetails.length > 0 && (
                      <Box sx={{ width: '100%', maxHeight: '30vh', overflowY: 'auto' }}>
                            <Errors list={errorDetails} showUUID={Boolean(new URLSearchParams(document.location.search).get('uuid'))} />
                        </Box>
                    )}

                    <DefaultButton
                        titleText={reload ? translate('try_again') : closeOnly ? translate('close') : translate('go_back')}
                        sx={{ backgroundColor: '#2E6FAB', fontWeight: 600, fontSize: '18px', fontFamily: 'Inter !important', minWidth: '270px', width: 'auto', whiteSpace: 'nowrap' }}
                        onClick={() => {
                            if (reload) return reloadWithoutStaleUuid()
                            onClose?.()
                            if (!closeOnly) navigate(-1)
                        }}
                    />
                </Box>
            </DialogContent>
        </Dialog>
        </ThemeProvider>
    )
}

export default ModalHandleError
